function expandMenu(){
  
document.getElementById("menuIcon").addEventListener("click", () => {
    var expandedMenu = document.getElementById("expandedMenu");
    var menuIcon = document.getElementsByClassName("svgIcon-menu")[0];
    var menuText = document.getElementById("menuIcon");

    


        // Mobile View Menu
        if(expandedMenu.offsetWidth != 0){
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="none";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="none";
            expandedMenu.style.width = "0";
            menuIcon.style.fill = "#000";
            menuText.getElementsByTagName('span')[0].style.color="#000";
            document.getElementById("modal-overlay").style.display = "none";

            document.body.style.overflow = ''; 

            header.style.backgroundColor = "rgba(0, 0, 0, 0)";
        }else{
            window.scrollTo(0, 0);
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="block";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="block";
            expandedMenu.style.width = "100%";
            document.body.style.overflow = 'hidden';
            menuIcon.style.fill = "#009aa9";
            menuText.getElementsByTagName('span')[0].style.color="#009aa9";
            document.getElementById("modal-overlay").style.display = "block";


            header.style.backgroundColor = "white";
        }
    
}); 


}


function MobileExpandL2MenuOnL1Click(){
    var mobileMenu = document.getElementsByClassName("mobile-menu")[0];
    var l1MenuItems = mobileMenu.querySelectorAll(".l1-menu-item");
    var l2MenuContainer = mobileMenu.querySelector("#l2MenuContainer");
    var l3MenuContainer = mobileMenu.querySelector("#l3MenuContainer");
    var menuIcon = document.getElementsByClassName("svgIcon-menu")[0];
    var closeButton = mobileMenu.querySelector(".close_menu-btn");
    var menuText = document.getElementById("menuIcon");
    var trackbackbutton ;

    for (let i = 0; i < l1MenuItems.length; i++) {
        const item = l1MenuItems[i];

        item.addEventListener("click", () => {
            var itemIdentifier = item.dataset.value;
            var correspondingL2MenuContent = document.getElementById(itemIdentifier);
            var backMenuBtn = document.querySelector(".back_menu-btn");
            l2MenuContainer.innerHTML = correspondingL2MenuContent.innerHTML;
            l2MenuContainer.style.width = "100%";
            l2MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
                element.style.display = "flex";
            });
            trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
            document.getElementById("mobile-menu_headertitle").innerHTML = itemIdentifier;
            backMenuBtn.style.visibility="unset";
            backMenuBtn.addEventListener("click", () => {
                if(l3MenuContainer.style.width == '0px' ){
                    if (l2MenuContainer.offsetWidth != 0) {
                        l2MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
                            element.style.display = "none";
                        });
                        l2MenuContainer.style.width = "0";
                        document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
                        backMenuBtn.style.visibility="hidden";
                    }
                }else{                
                    l3MenuContainer.style.width = "0";
                }
            });
            MobileExpandL3MenuOnL2Click();
        });
    }


    closeButton.addEventListener("click", () => {
        if (l2MenuContainer.offsetWidth != 0) {
            mobileMenu.getElementsByClassName("menu-body")['0'].style.display="none";
            mobileMenu.getElementsByClassName("menu-header")['0'].style.display="none";
            l2MenuContainer.style.width = "0";
            if(trackbackbutton)
                document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
            else{
                trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
                document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
            }

            mobileMenu.style.width = "0";
            document.body.style.overflow = ''; 
            menuIcon.style.fill = "#000";
            menuText.getElementsByTagName('span')[0].style.color="#000";
            document.getElementById("modal-overlay").style.display = "none";

        }else{
            mobileMenu.style.width = "0";
            document.body.style.overflow = ''; 
            menuIcon.style.fill = "#000";
            menuText.getElementsByTagName('span')[0].style.color="#000";
            document.getElementById("modal-overlay").style.display = "none";
        }
    });
}







function MobileExpandL3MenuOnL2Click(){
    var mobileMenu = document.getElementsByClassName("mobile-menu")[0];
    var l2MenuItems = document.querySelectorAll(".l2-menu-item");
    var l3MenuContainer = mobileMenu.querySelector("#l3MenuContainer");
    var menuIcon = document.getElementsByClassName("svgIcon-menu")[0];
    var closeButton = mobileMenu.querySelector(".close_menu-btn");
    var menuText = document.getElementById("menuIcon");
    var trackbackbutton ;



    l2MenuItems.forEach(function(item) {


        item.addEventListener("click", () => {
            var itemIdentifier = item.dataset.value;
            var correspondingL2MenuContent = document.getElementById(itemIdentifier);
            l3MenuContainer.innerHTML = correspondingL2MenuContent.innerHTML;
            l3MenuContainer.style.width = "100%";
            l3MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
                element.style.display = "block";
            });
            trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
            document.getElementById("mobile-menu_headertitle").innerHTML = itemIdentifier;
        });
    });


    closeButton.addEventListener("click", () => {
        if (l3MenuContainer.offsetWidth != 0) {
            l3MenuContainer.style.width = "0";
            if(trackbackbutton)
                document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
            mobileMenu.style.width = "0";
            document.body.style.overflow = ''; 
            menuIcon.style.fill = "#000";
            menuText.getElementsByTagName('span')[0].style.color="#000";
            document.getElementById("modal-overlay").style.display = "none";


        }else{
            mobileMenu.style.width = "0";
            document.body.style.overflow = ''; 
            menuIcon.style.fill = "#000";
            menuText.getElementsByTagName('span')[0].style.color="#000";
            document.getElementById("modal-overlay").style.display = "none";
        }
    });
}








function stickyHeaderOnScroll() {
    var header = document.getElementsByClassName("desktop-header")[0];
    var textLogo = document.getElementById("textLogo");
    var iconLogo = document.getElementById("iconLogo");
    
    if (header) {
        window.onscroll = function() {
            var sticky = header.offsetTop;

            if (window.pageYOffset > sticky) {
                textLogo.style.opacity = "0";
                iconLogo.style.opacity = "1";
            } else {
                textLogo.style.opacity = "1";
                iconLogo.style.opacity = "0";
            }
        };
    }
}




expandMenu();
MobileExpandL2MenuOnL1Click();
stickyHeaderOnScroll();